import React, { useState, useEffect } from "react";
import { FaRegRegistered, FaFileUpload, FaFilePdf } from "react-icons/fa";
import { FaFilePen } from "react-icons/fa6";
import { GiFarmer, GiArchiveRegister } from "react-icons/gi";
import { SiLimesurvey } from "react-icons/si";
import { ImFileOpenoffice } from "react-icons/im";
import { IoMdArrowDropdown } from "react-icons/io";
import { BsWhatsapp } from "react-icons/bs";
import { MdMyLocation } from "react-icons/md";
import { AiFillMerge } from "react-icons/ai";
import { LuActivity, LuUserPlus } from "react-icons/lu";
import { RiPassExpiredFill } from "react-icons/ri";
import { getCookie } from "../Utils/cookies";
import { NavLink } from "react-router-dom";
import { MdDashboard } from "react-icons/md";

const SideMenubar = ({ isOpen, setIsOpen }) => {
  const [surveyToggle, setSurveyToggle] = useState(false);
  const [farmerToggle, setFarmerToggle] = useState(false);
  const [maharashtraToggle, setMaharashtratoggle] = useState(false);
  const [showComplaintListToggled, setComplaintListToggled] = useState(false);
  const [insuranceToggle, setInsuranceToggle] = useState(false);
  const [filingToggle, setFilingToggle] = useState(false);
  const [installer, setInstaller] = useState(false);
  const [crmToggle, setCRMToggle] = useState(false);
  const [empData, setEmpData] = useState({});
  const [accountToggle, setAccountToggle] = useState(false);
  useEffect(() => {
    const data = getCookie("empData") ? JSON.parse(getCookie("empData")) : "";
    console.log("EmpData in SideMenubar:", data);
    setEmpData(data);
  }, []);
  const complaintListOptions = [
    {
      _id: "674d550dcd1e4fdc7a8285e7",
      stage: "Not Assigned",
    },
    {
      _id: "67501cde3a9836b55dd9f418",
      stage: "Resolved By (ST)",
    },
    {
      _id: "67501cde3a9836b55dd9f417",
      stage: "Assigned",
    },
    {
      _id: "67501cde3a9836b55dd9f41a",
      stage: "Rejected By (ST)",
    },
    {
      _id: "675be30222ae6f63bf772dd0",
      stage: "Resolve By (FS)",
    },
    {
      _id: "675be30222ae6f63bf772dd1",
      stage: "Reject By (FS)",
    },
    {
      _id: "675be30222ae6f63bf772dcf",
      stage: "Pending By (FS)",
    },
    {
      _id: "675d3477835297882dd66cd2",
      stage: "Verify Stage 2",
    },
    {
      _id: "676160e4ee8e5f880ec33945",
      stage: "Reject By (VT-2)",
    },
    {
      _id: "6793729a76b16307616f46c6",
      stage: "Resolve By Fota",
    },
    {
      _id: "67b846723e4585667059393f",
      stage: "Verify By Head Office Team",
    },
    {
      _id: "67c824e7d16853e3982439ff",
      stage: "Call Issue",
    },
  ];
  const SINGLE_ITEMS = [
    {
      label: "Complaint Register",
      icon: <FaFilePen className="text-dark" />,
      to: "complaintRegister",
      show: (empData) =>
        ["Tollfree", "Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Employee Register",
      icon: <FaRegRegistered />,
      to: "employeeRegister",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Excel Upload",
      icon: <FaFileUpload className="text-dark" />,
      to: "excelUpload",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Report",
      icon: <FaFilePen className="text-dark" />,
      to: "report",
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Transport",
          "Super Admin",
        ].includes(empData.role),
    },
    {
      label: "Update Photo",
      icon: <FaFileUpload className="text-dark" />,
      to: "udpatePhoto",
      show: (empData) => ["Super Admin"].includes(empData.role),
    },
    {
      label: "Permission",
      icon: <FaFilePen className="text-dark" />,
      to: "permission",
      show: (empData) => ["Super Admin"].includes(empData.role),
    },
    {
      label: "WhatsApp",
      icon: <BsWhatsapp className="text-dark" />,
      to: "WhatsAppPage",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Show Images",
      icon: <FaFilePen className="text-dark" />,
      to: "showImages",
      show: (empData) =>
        ["Admin", "Super Admin", "Service", "Tollfree", "Installer"].includes(
          empData.role,
        ),
    },
    {
      label: "Employee Track",
      icon: <MdMyLocation className="text-dark" />,
      to: "EmpTrack",
      show: (empData) =>
        ["Admin", "Super Admin", "Service", "Transport"].includes(empData.role),
    },
    {
      label: "RMU",
      icon: <LuActivity className="text-dark" />,
      to: "rmu",
      show: (empData) => ["RMU", "Super Admin"].includes(empData.role),
    },
  ];

  const FARMER_ITEMS = [
    {
      label: "REGISTER",
      icon: <GiArchiveRegister />,
      to: "farmerRegister",
      show: (empData) =>
        ["Admin", "Service", "Tollfree", "Super Admin"].includes(
          empData?.role,
        ) && ["Department Head"].includes(empData.department),
    },
    {
      label: "OLD FARMER",
      icon: <GiFarmer />,
      to: "ShowFarmerDataDashboard",
      show: (empData) =>
        ["Admin", "Service", "Tollfree", "Super Admin"].includes(empData?.role),
    },
    {
      label: "NEW FARMER",
      icon: <GiFarmer />,
      to: "newFarmer",
      show: (empData) =>
        ["Admin", "Service", "Tollfree", "Super Admin"].includes(empData?.role),
    },
    {
      label: "FARMER EXPIRED",
      icon: <RiPassExpiredFill />,
      to: "farmerExpired",
      show: (empData) =>
        ["Admin", "Super Admin"].includes(empData?.role) &&
        ["Department Head"].includes(empData.department),
    },
  ];
  const INSTALLER_ITEMS = [
    {
      label: "Installer List",
      icon: <LuActivity />,
      to: "installerList",
      show: (empData) =>
        ["Admin", "Service", "Super Admin"].includes(empData?.role) &&
        ["Department Head"].includes(empData.department),
    },
    {
      label: "Add Installer",
      icon: <LuActivity />,
      to: "addInstaller",
      show: (empData) =>
        ["Admin", "Super Admin"].includes(empData?.role) &&
        ["Department Head"].includes(empData.department),
    },
    {
      label: "Payment Request",
      icon: <LuUserPlus />,
      to: "paymentRequest",
      show: (empData) =>
        ["Service", "Admin", "Installer", "Installation", "Transport", "Super Admin"].includes(
          empData?.role,
        ),
    },
    {
      label: "Meter Approved List",
      icon: <LuActivity />,
      to: "meterApprovedList",
      show: (empData) =>
        ["Admin", "Super Admin"].includes(empData?.role) &&
        ["Department Head"].includes(empData.department),
    },
  ];
  const FILING = [
    {
      label: "Generate PDF",
      icon: <FaFilePdf className="text-dark" />,
      to: "GeneratePDF",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role) &&
        ["Department Head","Document Verify Team-1"].includes(empData.department),
    },
    {
      label: "Upload Invoice",
      icon: <FaFilePdf className="text-dark" />,
      to: "UploadInvoice",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role) &&
        ["Department Head","Document Verify Team-1"].includes(empData.department),
    },
  ];
  const SURVEY = [
    {
      label: "Installation Survey",
      icon: <ImFileOpenoffice className="text-dark" />,
      to: "installationSurveyList",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Quarterly Survey",
      icon: <ImFileOpenoffice className="text-dark" />,
      to: "QuarterlyVisit",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Quality Survey",
      icon: <ImFileOpenoffice className="text-dark" />,
      to: "qualitySurveyList",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
  ];
  const maharashtraItems = [
    {
      label: "Complaint Register",
      icon: <GiArchiveRegister className="text-dark" />,
      to: "MaharashtraComplaintRegister",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Complaint List",
      icon: <GiFarmer className="text-dark" />,
      to: "MaharashtraComplaintList",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },

        {
      label: "New Installation History",
      icon: <GiFarmer className="text-dark" />,
      to: "NewInstallationHistory",
      show: (empData) => ["Service"].includes(empData.role),
    },
    {
      label: "Service Person Registration",
      icon: <GiFarmer className="text-dark" />,
      to: "ServicePersonRegistration",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Show All ServicePerson",
      icon: <GiFarmer className="text-dark" />,
      to: "ShowAllServicePerson",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Material List",
      icon: <GiFarmer className="text-dark" />,
      to: "MaterialList",
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Assign Installation",
      icon: <GiFarmer className="text-dark" />,
      to: "MhAssignInstallation",
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData.role) &&
        ["Department Head", "Document Verify Team-1"].includes(
          empData.department,
        ),
    },
    {
      label: "Installation List",
      icon: <GiFarmer className="text-dark" />,
      to: "InstallationList",
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData.role) &&
        ["Department Head", "Document Verify Team-1"].includes(
          empData.department,
        ),
    },
    {
      label: "Approved List",
      icon: <GiFarmer className="text-dark" />,
      to: "ApprovedList",
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData.role) &&
        ["Department Head", "Document Verify Team-1"].includes(
          empData.department,
        ),
    },
    {
      label: "Installation Done",
      icon: <GiFarmer className="text-dark" />,
      to: "InstallationDone",
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData.role) &&
        [
          "Department Head",
          "Document Verify Team-1",
          "Document Verify Team-2",
        ].includes(empData.department),
    },
    {
      label: "Verify Image",
      icon: <GiFarmer className="text-dark" />,
      to: "VerifyImage",
      show: (empData) =>
        ["Super Admin", "Service"].includes(empData.role) &&
        ["Department Head", "Document Verify Team-2"].includes(
          empData.department,
        ),
    },
    {
      label: "Verified Image",
      icon: <GiFarmer className="text-dark" />,
      to: "VerifiedImageHistory",
      show: (empData) =>
        ["Super Admin", "Service"].includes(empData.role) &&
        [
          "Department Head",
          "Document Verify Team-1",
          "Document Verify Team-2",
        ].includes(empData.department),
    },
  ];
  const CRM_ITEMS = [
    {
      label: "Enquiry List",
      icon: <GiFarmer className="text-dark" />,
      to: "enquiryList",
      show: (empData) =>
        ["Super Admin", "Admin"].includes(empData.role) &&
        ["Department Head", "Filing Head"].includes(empData.department),
    },
  ];

  const INSURANCE_ITEMS = [
    {
      label: "Pending Insurance",
      icon: <AiFillMerge className="text-dark" />,
      to: "insurance",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Installed List",
      icon: <GiFarmer className="text-dark" />,
      to: "pendingInsuranceList",
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
  ];
  const ACCOUNT_ITEMS = [
    {
      label: "Installer",
      icon: <GiFarmer className="text-dark" />,
      to: "installerPaymentList",
      show: (empData) => ["Account"].includes(empData.role),
    },
    {
      label: "Insurance",
      icon: <GiFarmer className="text-dark" />,
      to: "InsuranceList",
      show: (empData) => ["Account"].includes(empData.role),
    },
    {
      label:"Vehicle Payment",
      icon:<GiFarmer className="text-dark" />,
      to:"Account",
      show:(empData) => ["Account"].includes(empData.role),
    }
  ];
  const SIDEBAR_ITEMS = [
    {
      label: "Farmer",
      icon: <GiFarmer />,
      toggle: farmerToggle,
      setToggle: setFarmerToggle,
      items: FARMER_ITEMS,
      show: (empData) => true,
    },
    {
      label: "Filling",
      icon: <AiFillMerge className="text-dark" />,
      toggle: filingToggle,
      setToggle: setFilingToggle,
      items: FILING,
      show: (empData) =>
        ["Admin", "Service", "Super Admin"].includes(empData.role),
    },
    {
      label: "Insurance",
      icon: <AiFillMerge className="text-dark" />,
      toggle: insuranceToggle,
      setToggle: setInsuranceToggle,
      items: INSURANCE_ITEMS,
      show: (empData) => ["Admin", "Super Admin"].includes(empData.role),
    },
    {
      label: "Survey",
      icon: <SiLimesurvey className="text-dark" />,
      toggle: surveyToggle,
      setToggle: setSurveyToggle,
      items: SURVEY,
      show: (empData) =>
        ["Admin", "Super Admin", "Service"].includes(empData.role),
    },
    {
      label: "Maharashtra",
      icon: <GiFarmer className="text-dark" />,
      toggle: maharashtraToggle,
      setToggle: setMaharashtratoggle,
      items: maharashtraItems,
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData.role),
    },
    {
      label: "Installer Pay",
      icon: <GiFarmer className="text-dark" />,
      toggle: installer,
      setToggle: setInstaller,
      items: INSTALLER_ITEMS,
      show: (empData) =>
        [
          "Admin",
          "Super Admin",
          "Service",
          "Installation",
          "Transport",
        ].includes(empData?.role),
    },
    {
      label: "CRM",
      icon: <GiFarmer className="text-dark" />,
      toggle: crmToggle,
      setToggle: setCRMToggle,
      items: CRM_ITEMS,
      show: (empData) =>
        ["Admin", "Super Admin"].includes(empData?.role) &&
        ["Department Head", "Filing Head"].includes(empData?.department),
    },
    {
      label: "Account",
      icon: <MdMyLocation className="text-dark" />,
      toggle: accountToggle,
      setToggle: setAccountToggle,
      items: ACCOUNT_ITEMS,
      show: (empData) => ["Account"].includes(empData.role),
    },
  ];
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div
        className={`fixed md:static top-0 left-0 z-50
        h-full md:h-[calc(100vh-5rem)]
        w-64 bg-white shadow-lg
        transform transition-all duration-300
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        md:translate-x-0
        overflow-y-auto flex flex-col`}
      >
        {/* ✅ Mobile header */}

        <div className="sticky top-0 bg-white border-b border-gray-200 z-50">
          <div className="flex items-center justify-between p-4 md:hidden">
            <button className="" onClick={() => setIsOpen(false)}>
              ✕
            </button>
          </div>
        </div>
        {/* ✅ Dashboard */}
        <NavLink
          to="/dashboard"
          onClick={() => setIsOpen(false)}
          className={({ isActive }) =>
            `mx-3 mt-3 flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
              isActive
                ? "bg-yellow-400 text-black shadow-md"
                : "text-gray-700 hover:bg-yellow-50 hover:text-yellow-700"
            }`
          }
        >
          <MdDashboard size={20} />
          <span className="font-medium">Dashboard</span>
        </NavLink>

        <div className="space-y-1">
          {SINGLE_ITEMS.map(
            (item, idx) =>
              item.show(empData) && (
                <NavLink
                  key={idx}
                  to={item.to}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    `relative flex items-center gap-3 px-4 py-1 rounded-xl transition-all duration-300 group
            ${
              isActive
                ? "bg-gradient-to-r from-yellow-500 to-amber-500 text-white shadow-lg"
                : "text-gray-700 hover:bg-yellow-50 hover:text-yellow-600"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {/* Active Indicator */}
                      {isActive && (
                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-white rounded-r-full" />
                      )}

                      {/* Icon */}
                      <div
                        className={`flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-300
                      ${
                        isActive
                          ? "bg-white/20"
                          : "bg-gray-100 group-hover:bg-indigo-100"
                      }`}
                      >
                        {item.icon}
                      </div>

                      {/* Label */}
                      <span className="font-medium text-sm">{item.label}</span>
                    </>
                  )}
                </NavLink>
              ),
          )}
        </div>
        <div className="spacer-y-1">
          {[
            "Admin",
            "Service",
            "Tollfree",
            "Super Admin",
            "Verify Team-2",
          ].includes(empData?.role) && (
            <>
              {/* Parent Menu */}
              <button
                type="button"
                onClick={() => {
                  setComplaintListToggled((prev) => !prev);
                  setMaharashtratoggle(false);
                }}
                className="w-full flex items-center justify-between px-4 py-1 rounded-xl text-gray-700 hover:bg-yellow-50 hover:text-yellow-700 transition-all duration-300 group"
              >
                <div className="flex items-center gap-3">
                  <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 group-hover:bg-yellow-100 transition-all duration-300">
                    <GiFarmer className="text-lg" />
                  </div>

                  <span className="font-medium text-sm">Complaint List</span>
                </div>

                <IoMdArrowDropdown
                  className={`w-5 h-5 transition-transform duration-300 ${
                    showComplaintListToggled ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Child Menus */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  showComplaintListToggled ? "max-h-[1000px]" : "max-h-0"
                }`}
              >
                <div className="ml-5 border-l-2 border-yellow-200 pl-3 py-1">
                  {complaintListOptions?.map(({ _id, stage }) => (
                    <NavLink
                      key={_id}
                      to={`/complaintList/${_id}`}
                      className={({ isActive }) =>
                        `relative group flex items-center gap-3 px-4 py-1 rounded-xL transition-all duration-300 overflow-hidden ${
                          isActive
                            ? "bg-gradient-to-r from-yellow-400 to-amber-500 text-black shadow-lg"
                            : "text-gray-600 hover:bg-yellow-50 hover:text-yellow-700 hover:translate-x-1"
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          {/* Active Indicator */}
                          {isActive && (
                            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-black rounded-r-full" />
                          )}

                          {/* Icon */}
                          <div
                            className={`flex items-center justify-center w-6 h-6 rounded-lg transition-all duration-300 ${
                              isActive
                                ? "bg-white/40"
                                : "bg-gray-100 group-hover:bg-yellow-100"
                            }`}
                          >
                            <GiArchiveRegister />
                          </div>

                          {/* Stage Name */}
                          <span className="text-sm font-medium truncate">
                            {stage}
                          </span>
                        </>
                      )}
                    </NavLink>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="space-y-1">
          {SIDEBAR_ITEMS.map(
            (item, index) =>
              item.show(empData) && (
                <React.Fragment key={index}>
                  {/* Parent Menu */}
                  <button
                    onClick={() => item.setToggle(!item.toggle)}
                    className="w-full flex items-center justify-between px-4 py-1 rounded-xl text-gray-700 hover:bg-yellow-50 hover:text-yellow-700 transition-all duration-300 group"
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 group-hover:bg-yellow-100 transition-all duration-300">
                        {item.icon}
                      </div>

                      <span className="font-medium text-sm">{item.label}</span>
                    </div>

                    <IoMdArrowDropdown
                      className={`w-5 h-5 transition-transform duration-300 ${
                        item.toggle ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Child Menus */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      item.toggle ? "max-h-[500px]" : "max-h-0"
                    }`}
                  >
                    <div className="ml-5 border-l-2 border-yellow-200 pl-3 py-1">
                      {item.items.map(
                        (subItem, idx) =>
                          subItem.show(empData) && (
                            <NavLink
                              key={idx}
                              to={subItem.to}
                              onClick={() => setIsOpen(false)}
                              className={({ isActive }) =>
                                `relative group flex items-center gap-3 px-4 py-1 rounded-xl transition-all duration-300 overflow-hidden ${
                                  isActive
                                    ? "bg-gradient-to-r from-yellow-400 to-amber-500 text-black shadow-lg"
                                    : "text-gray-600 hover:bg-yellow-50 hover:text-yellow-700 hover:translate-x-1"
                                }`
                              }
                            >
                              {({ isActive }) => (
                                <>
                                  {/* Active Indicator */}
                                  {isActive && (
                                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-4 bg-white rounded-r-full" />
                                  )}
                                  {/* Icon */}
                                  <div
                                    className={`flex items-center justify-center w-6 h-6 rounded-lg transition-all duration-300 ${
                                      isActive
                                        ? "bg-white/40"
                                        : "bg-gray-100 group-hover:bg-yellow-100"
                                    }`}
                                  >
                                    {subItem.icon}
                                  </div>
                                  {/* Label */}
                                  <span className="text-sm font-medium">
                                    {subItem.label}
                                  </span>
                                </>
                              )}
                            </NavLink>
                          ),
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ),
          )}
        </div>
      </div>
    </>
  );
};
export default SideMenubar;
